import { Injectable, isDevMode } from '@angular/core';
import { SetupHandler } from './setup.handler';

@Injectable({
  providedIn: 'root'
})
export class LogInfoHandler extends SetupHandler {
  constructor() {
    super('log-info.handler');
  }

  handle() {
    this.addLogMessage(!isDevMode() ? '🏭 production' : '🚧 development');
  }
}
